import { RowData } from "@tanstack/react-table";
import useEvent from "react-use-event-hook";
import { useRecoilState, useSetRecoilState } from "recoil";

import { usePageContext } from "@ryde/redux";
import {
  IExtendableDto,
  IRydeRow,
  isEntityWithoutBulkActions,
  isSelectedIdSF,
  isStarredTableRowIdSF,
} from "@ryde/shared";

import { CheckboxMui, CheckboxStar } from "../../../controls";
import { useTableRowIsSelected } from "../table/selection-context";

export const CellMultiIconGeneric = <T extends RowData>({
  original,
}: Pick<IRydeRow<T>, "original">): JSX.Element => {
  const { entity } = usePageContext();

  const id = (original as IExtendableDto).id;

  const isSelected = useTableRowIsSelected(entity, id);
  const setIsSelected = useSetRecoilState(isSelectedIdSF([entity, id]));
  const [isStarred, setIsStarred] = useRecoilState(
    isStarredTableRowIdSF([entity, id]),
  );

  const handleSelectToggle = useEvent((): void => {
    setIsSelected(selected => !selected);
  });

  const handleStarredToggle = useEvent((): void => {
    setIsStarred(starred => !starred);
  });
  return (
    <div className="multi_icon_cell">
      {!isEntityWithoutBulkActions(entity) && (
        <CheckboxMui
          checked={isSelected}
          onCheckboxToggle={handleSelectToggle}
        />
      )}
      <CheckboxStar
        checked={isStarred}
        onCheckboxToggle={handleStarredToggle}
      />
    </div>
  );
};
